var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M4.78873 9.01408L10.1972 3.60563L9.35211 2.73239L4.78873 7.29577L2.64789 5.15493L1.80282 6L4.78873 9.01408ZM1.74648 1.77465C2.92958 0.591549 4.34742 0 6 0C7.65258 0 9.06103 0.591549 10.2254 1.77465C11.4085 2.93897 12 4.34742 12 6C12 7.65258 11.4085 9.07042 10.2254 10.2535C9.06103 11.4178 7.65258 12 6 12C4.34742 12 2.92958 11.4178 1.74648 10.2535C0.58216 9.07042 0 7.65258 0 6C0 4.34742 0.58216 2.93897 1.74648 1.77465Z",
    fill: "#80BF07"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.af7bce26b567ca1c830c4afaac588fa2.svg";
export { ForwardRef as ReactComponent };